import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';

import type { DispositionOptionType } from './types';

const useGetAvailableDispositionOptions = () => {
  const [dispositionOptions, setDispositionOptions] = useState<DispositionOptionType[]>([]);
  const [loading, setLoading] = useState(true);

  const getDispositionOptions = async () => {
    setLoading(true);
    try {
      const response = await api.get('/disposition_option/available');
      setDispositionOptions(response.data);
    } catch {
      toast.error('Erro ao carregar as opções disponíveis. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDispositionOptions();
  }, []);

  return {
    dispositionOptions,
    loading,
  };
};

export default useGetAvailableDispositionOptions;
